import {Intent} from '@blueprintjs/core/lib/esm/index';
import React, {PureComponent} from 'react';

import {Classes, Overlay, Collapse, Button, MenuItem, Callout} from "@blueprintjs/core";
import {Link} from "react-router-dom";
import {getCurrentUserId, getJwt} from "../../services/authService";
import http from "../../services/httpService";
import toastr from "toastr";
import InputRegular from '../common/InputRegular';

export default class InviteAdminsModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        done: false,
        teamMembers: ['member_1'],
        //teamMembers: ['member_1', 'member_2', 'member_3'],
        team_name: this.props.team_name || "",
        team_id: this.props.team_id || "",
        data: {

            member_1: '',
            // member_2: '',
            // member_3: ''
        },
        spinnerActive: false,
        errors: {},
        fieldsCheckActive: false,
        errorsList: [],
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false,
        })
    }

    getEmailsFromInputs = () => {
        const collection = document.getElementsByTagName("input");
        const inputs = [...collection];

        const emails = inputs.map(input => {
            if (input.value) {
                return input.value;
            } else {
                return null
            }
        });
        return emails.filter(function (el) {
            return el != null;
        });
    };


    showInviteLink = () => {
        let show = this.state.showLink;
        show = show !== true;
        this.setState({
            showLink: show
        })
    };


    addNewMember = () => {
        let teamMembers = [...this.state.teamMembers];
        let membersCount = teamMembers.length + 1;
        let newMember = 'member_' + membersCount;

        teamMembers.push(newMember);
        // let schema = {...this.schema};
        let data = {...this.state.data};
        data[newMember] = '';
        // schema[newMember] = Joi.string().email().allow('').label('The field');
        // this.schema = schema;
        this.setState({
                teamMembers: this.state.teamMembers.concat(newMember),
                data: data
            }
        );
    };

    doSubmit = async (e) => {
        await this.setState({fieldsCheckActive: true})
        const data = await this.state.data;
        const team_id = await this.state.team_id || this.props.team_id || '';
        const emails = await this.getEmailsFromInputs();
        // await console.log('data: ', data);
        // await console.log('teamId: ', team_id);
        // await console.log('emails: ', emails);
        // await console.log('user', this.props.user);
        // await console.log('projectId', this.props.projectId);

        setTimeout(async () => {
            let anyErrorActive = await this.state.data.member_1 ? false : true;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            if (!anyErrorActive) {
                this.setState({spinnerActive: true})
                if (this.props.type === 'teamAdmin') {
                    try {
                        const result = await http.post('api/user/' + this.props.user.id + '/team/' + team_id + '/member', {emails: emails}, {headers: {authorization: getJwt()}});
                        this.props.getTeams();
                        this.setState({
                            spinnerActive: false,
                            data: {
                                member_1: '',
                                member_2: '',
                                member_3: ''
                            },
                            fieldsCheckActive: false,
                            errorsList: [],
                        });
                        this.props.handleClose();
                        if (this.props.updateWorkspaceData){
                        await this.props.updateWorkspaceData()
                        }
                    } catch (e) {
                        this.setState({spinnerActive: false})
                        toastr.error("Adding emails to Workspace wasn't successful")
                    }

                } else {
                    try {
                        let resp = await http.post('api/user/' + this.props.user.id + '/feed/' + this.props.projectId + '/admin', {emails: emails}, {headers: {authorization: getJwt()}});
                        this.props.getTeams();
                        this.setState({spinnerActive: false})
                        this.props.handleClose();
                        if (this.props.updateWorkspaceData){
                            await this.props.updateWorkspaceData()
                        }

                    } catch (e) {
                        this.setState({spinnerActive: false})
                        toastr.error("Adding emails to Workspace wasn't successful")
                    }
                }
                // this.props.acceptModal(e, data, team_id, emails);
            }
        }, 300)

    };

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal
        })
    }

    render() {

        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={this.state.billingDetailsOpen ? (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400') : Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2>{this.props.type === 'teamAdmin' ? 'Invite team admin' : 'Invite workspace admin'}</h2>
                        </div>
                        <div className='modal-main'>
                            <div className='margin-top-20 margin-bottom-10'>
                                {
                                    this.props.type === 'teamAdmin' ?
                                        <p className='m-m-b'>Team admins will be granted admin access to <span
                                            className='text-bold'>all workspace</span>
                                            <br/>
                                            within <span
                                                className='text-light-blue'>&lt;{this.state.team_name}&gt;</span> team.
                                        </p>
                                        :
                                        <p className='m-m-b'>Workspace admins will be granted admin access to <br/>

                                            <span
                                                className='text-light-blue'>&lt;{this.props.project_name}&gt;</span> only.
                                        </p>
                                }

                                <div id='team-members'>

                                    {this.state.teamMembers.map((member, index) => {


                                            return <div key={member}>
                                                <InputRegular
                                                    id={(index + 1).toString()}
                                                    label1=""
                                                    label2=""
                                                    placeholder="Email"
                                                    type='email'
                                                    onChange={async (value) => {
                                                        let errorsList = this.state.errorsList;
                                                        if (index.toString() !== '0' && value === '') {
                                                            errorsList[index] = await false;
                                                        }
                                                        await this.setState({
                                                            data: {
                                                                ...this.state.data,
                                                                ['member_' + (index + 1)]: value
                                                            },
                                                            errorsList
                                                        });
                                                    }}
                                                    value={this.state.data['member_' + (index + 1)]}
                                                    required={index.toString() === '0' || this.state.data['member_' + (index + 1).toString()] ? true : false}
                                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                                    updateErrorsList={this.updateErrorsList}
                                                    errorMessage="Please enter valid email address"
                                                />
                                            </div>
                                        }
                                    )
                                    }


                                </div>
                                {/*<p className=' add-new-member  m-s-t m-m-b text-right'>*/}
                                {/*    <p className='text-light-blue pointer' onClick={this.addNewMember}>*/}
                                {/*        <span className='fas fa-plus-circle'></span>*/}
                                {/*        Add another*/}
                                {/*    </p>*/}
                                {/*</p>*/}

                                <div className='justify-content-space flex-direction-row margin-bottom-20'>
                                    <button onClick={this.props.handleClose} className='btn-white-border'>Cancel
                                    </button>
                                    {!this.state.spinnerActive ?
                                        <button
                                            // disabled={this.validate()}
                                            onClick={this.doSubmit}
                                            name="invite_team"
                                            id="change_team"
                                            type="button"
                                            className='btn-action'>Add Teammates</button> :
                                        <button className='btn-action btn-spinner' disabled={true}>Add Teammates <i
                                            className='fa fa-spin fa-spinner'></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}